import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './devkitcomponents/header/header.component';
import { TopBarComponent } from './devkitcomponents/top-bar/topBar.component';
import { SiteLogoComponent } from './devkitcomponents/header/site-logo/siteLogo.component';
import { ToolBarComponent } from './devkitcomponents/header/tool-bar/toolBar.component';
import { SearchBarComponent } from './devkitcomponents/header/search-bar/searchBar.component';
import { MobileSearchBarComponent } from './devkitcomponents/header/mobile-search/mobileSearchBar.component';
import { UserGreetingComponent } from './devkitcomponents/header/user-greeting/userGreeting.component';
import { HamburgerMenuComponent } from './devkitcomponents/header/hamburger-menu/hamburgerMenu.component';
import { LeftNavComponent } from './devkitcomponents/left-nav/left-nav.component';
import { NavBarComponent } from './devkitcomponents/nav-bar/navBar.component';
import { FooterComponent } from './devkitcomponents/footer/footer.component';
import { FooterLinksComponent } from './devkitcomponents/footer/footer-links/footerLinks.component';
import { FooterLogoComponent } from './devkitcomponents/footer/footer-logo/footerLogo.component';
import { BottomBarComponent } from './devkitcomponents/bottom-bar/bottom-bar.component';
import { SecurityWarningComponent } from './appcomponents/security-warning/security-warning.component';
import { LandingPageComponent } from './appcomponents/landing-page/landing-page.component';
import { LoginComponent } from './appcomponents/login/login.component';
import {RouterModule, UrlSerializer} from '@angular/router';
import { DialogModule } from 'primeng/dialog';
import { AddAgentModalComponent } from './appcomponents/add-agent-modal/add-agent-modal.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogService } from 'primeng/dynamicdialog';
import {TooltipModule} from 'primeng/tooltip';
import { MessageService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import {  DynamicDialogRef } from 'primeng/dynamicdialog';
import { AuthGuardService } from './_auth/auth-guard.service';
import { AuthService } from './_auth/auth.service';
import { UserDataService } from './shared/services/user-data.service';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { USASHttpInterceptorService } from './shared/services/USASHttpInterceptorService';
import { UsasLoadingComponent } from './shared/components/usas-loading/usas-loading.component';
import { FormatPhoneNumberPipe } from './shared/pipes/format-phone-number.pipe';
import { AccordionModule } from 'primeng/accordion';
import { AccessDeniedComponent } from '../app/appcomponents/access-denied/access-denied.component';
import { InputMask } from 'primeng/inputmask';
import { SearchpanelComponent } from './appcomponents/searchpanel/searchpanel.component';
import { SearchResultsComponent } from './appcomponents/search-results/search-results.component';
import { InternalLandingPageComponent } from './appcomponents/internal-landing-page/internal-landing-page.component';
import { DatePicker } from 'primeng/datepicker';
import { TableModule } from 'primeng/table';
import { AddInternalUserModalComponent } from './appcomponents/add-internal-user-modal/add-internal-user-modal.component';
import { InternalUserListComponent } from './appcomponents/internal-user-list/internal-user-list.component';
import { InternalUserPageComponent } from './appcomponents/internal-user-page/internal-user-page.component';
import { AddInternalUserSearchListComponent } from './appcomponents/add-internal-user-search-list/add-internal-user-search-list.component';
import { AddInternalUserSearchComponent } from './appcomponents/add-internal-user-search/add-internal-user-search.component';
import { AddInternalUserPageComponent } from './appcomponents/add-internal-user-page/add-internal-user-page.component';
import { Skeleton } from 'primeng/skeleton';
import { UserAccountComponent } from './appcomponents/user-account/user-account.component';
import { ChangePasswordComponent } from './appcomponents/change-password/change-password.component';
import { Password } from 'primeng/password';
import { ForgotPasswordComponent } from './appcomponents/forgot-password/forgot-password.component';
import { ConfirmVerifcationComponent } from './appcomponents/confirm-verifcation/confirm-verifcation.component';
import { UserIdleInactiveTimeoutComponent } from './appcomponents/user-idle-inactive-timeout/user-idle-inactive-timeout.component';
import { FaqListComponent } from './appcomponents/faq-list/faq-list.component';
import { ContactUsComponent } from './appcomponents/contact-us/contact-us.component';
import { Menu } from 'primeng/menu';
import { CustomUrlSerializer } from './shared/services/custom-rul-serialize';
import { AccountInfoComponent } from './appcomponents/account-info/account-info.component';
import { LandingComponent } from './documentation/landing/landing.component';
import { InternalComponent } from './documentation/internal/internal.component';
import { ExternalComponent } from './documentation/external/external.component';
import { ExternalUserDesignateComponent } from './documentation/external-user-designate/external-user-designate.component';
import { ExternalUserAccountComponent } from './documentation/external-user-account/external-user-account.component';
import { UserGuideComponent } from './documentation/user-guide/user-guide.component';
import { Card } from 'primeng/card';
import { SearchInternalUserComponent } from './documentation/search-internal-user/search-internal-user.component';
import { ManageInternalUserComponent } from './documentation/manage-internal-user/manage-internal-user.component';
import { DesignateAgentModalComponent } from './appcomponents/designate-agent-modal/designate-agent-modal.component';
import { DisplayAgentDetailsComponent } from './appcomponents/display-agent-details/display-agent-details.component';
import { provideUserIdleConfig } from 'angular-user-idle';
import { Button } from 'primeng/button';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { FAAThemePreset } from '../faatheme';
import { Select } from 'primeng/select';
import { DesignateAgentGuide } from './documentation/designate-agent-guide/designate-agent-guide.component'

import { ExternalAircraftDesignateComponent } from './documentation/external-aircraft-designate/external-aircraft-designate.component';
import { AdminSearchLandingPageComponent } from './appcomponents/admin-search-landing-page/admin-search-landing-page.component';
import { AdminSearchResultsComponent }  from './appcomponents/admin-search-results/admin-search-results.component';
import { AdminEditOperatorDetailsComponent } from './appcomponents/admin-edit-operator-details/admin-edit-operator-details.component';
import { AdminExternalSearchLandingPageComponent } from './appcomponents/admin-external-search-landing-page/admin-external-search-landing-page.component';
import { EllipsesTooltipDirective } from './shared/pipes/ellipses-tooltip.directive';
import { AdminBannerDetailsComponent } from './appcomponents/admin-banner-details/admin-banner-details.component';
import { Splitter } from "primeng/splitter";
import { MessageModule } from 'primeng/message';
import { FieldsetModule } from 'primeng/fieldset';

@NgModule({ declarations: [
        AppComponent,
        FooterComponent,
        FooterLinksComponent,
        FooterLogoComponent,
        HeaderComponent,
        TopBarComponent,
        SiteLogoComponent,
        ToolBarComponent,
        SearchBarComponent,
        MobileSearchBarComponent,
        UserGreetingComponent,
        HamburgerMenuComponent,
        LeftNavComponent,
        NavBarComponent,
        BottomBarComponent,
        SecurityWarningComponent,
        LandingPageComponent,
        AddAgentModalComponent,
        LoginComponent,
        UsasLoadingComponent,
        FormatPhoneNumberPipe,
        AccessDeniedComponent,
        SearchpanelComponent,
        SearchResultsComponent,
        InternalLandingPageComponent,
        AddInternalUserModalComponent,
        InternalUserListComponent,
        InternalUserPageComponent,
        AddInternalUserSearchListComponent,
        AddInternalUserSearchComponent,
        AddInternalUserPageComponent,
        UserAccountComponent,
        ChangePasswordComponent,
        ForgotPasswordComponent,
        ConfirmVerifcationComponent,
        UserIdleInactiveTimeoutComponent,
        FaqListComponent,
        ContactUsComponent,
        AccountInfoComponent,
        DesignateAgentModalComponent,
        DisplayAgentDetailsComponent,
        LandingComponent,
        InternalComponent,
        ExternalComponent,
        ExternalUserDesignateComponent,
        ExternalUserAccountComponent,
        UserGuideComponent,
        SearchInternalUserComponent,
        ManageInternalUserComponent,
        ExternalAircraftDesignateComponent,
        DesignateAgentGuide, 
        AdminSearchLandingPageComponent,
        AdminSearchResultsComponent,
        AdminEditOperatorDetailsComponent,
        AdminExternalSearchLandingPageComponent,
        EllipsesTooltipDirective,
        AdminBannerDetailsComponent
    ],
    exports: [
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
    CommonModule,
    AppRoutingModule,
    RouterModule,
    DialogModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    RadioButtonModule,
    CheckboxModule,
    TooltipModule,
    ToastModule,
    AccordionModule,
    InputMask,
    DatePicker,
    TableModule,
    Skeleton,
    Password,
    Menu,
    Card,
    Button,
    Select,
    Splitter,
    MessageModule, FieldsetModule
    ], 
    providers: [{ provide: HTTP_INTERCEPTORS, useClass: USASHttpInterceptorService, multi: true },
        { provide: UrlSerializer, useClass: CustomUrlSerializer },
        DialogService,
        MessageService,
        DynamicDialogRef,
        AuthGuardService,
        AuthService,
        UserDataService,
        provideUserIdleConfig({}), provideHttpClient(withInterceptorsFromDi()),
        provideAnimationsAsync(),
        providePrimeNG({ 
            theme: {
                preset: FAAThemePreset,
                options: {
                    prefix: 'p',
                    darkModeSelector: 'system',
                    cssLayer: false
                }
            }
        })] })
export class AppModule { }